import { Components, Theme } from '@mui/material';

export function getMuiPaper(theme: Theme): Components['MuiPaper'] {
  return {
    styleOverrides: {
      root: {
        borderRadius: theme.shape.borderRadiusLg,
        boxShadow: 'none',
      },
    },
  };
}
